import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { FuseConfigService } from "@fuse/services/config.service";
import { environment } from '../../../../environments/environment'

@Component({
    selector: "app-charger-home",
    templateUrl: "./charger-home.component.html",
    styleUrls: ["./charger-home.component.scss"],
})
export class ChargerHomeComponent implements OnInit {
    user_id: any = "";
    mobile_no: any = "";

    constructor(
        private _fuseConfigService: FuseConfigService,
        private router: Router
    ) {
        // Hide layout elements
        this._fuseConfigService.config = {
            layout: {
                navbar: { hidden: true },
                toolbar: { hidden: true },
                footer: { hidden: true },
                sidepanel: { hidden: true },
            },
        };
    }

    ngOnInit(): void {
        this.user_id = sessionStorage.getItem("web_user_id");
        this.mobile_no = sessionStorage.getItem("web_mobile");

        if (!this.user_id || !this.mobile_no) {
            this.router.navigate(["/web-login"]);
            return;
        }

        sessionStorage.removeItem("charger_data");

        this.checkActiveSession();
    }

    checkActiveSession(): void {
        fetch(
            // `https://cmsapi.vmatic.co.in/api-v3/app/chargStation/getActiveSessionbyUserId/${this.user_id}/${this.mobile_no}`
            `${environment.API_URL2}/api-v3/app/chargStation/getActiveSessionbyUserId/${this.user_id}/${this.mobile_no}`
        )
            .then((response) => {
                if (!response.ok) throw new Error("Network error");
                return response.json();
            })
            .then((data) => {
                if (
                    data?.status &&
                    data?.data?.[0]?.session_status === "Active"
                ) {
                    this.router.navigate(["/charger-status"]);
                }
            })
            .catch((err) => {
                console.error("Session check failed:", err);
            });
    }
}
